"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketCorsInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketCorsInput.js.map